import React, { FC } from 'react'
import { useSortedBookings } from '../hooks';
import SearchResultsInfo from '../../search/components/SearchResultsInfo';
import BookingsListItem from './BookingsListItem';
import BookingsListHeader from './BookingsListHeader';


const BookingsList: FC = () => {
  var bookings = useSortedBookings()

  if (bookings.length === 0) {
    return (
      <SearchResultsInfo />
    );
  }

  return (
    <div className="column">
      <SearchResultsInfo />
      <table className="table top-buffer">
        <thead>
          <tr>
            <th colSpan={2} className="cellLarge">
              <div className="fixer">
                <BookingsListHeader column="name">Name</BookingsListHeader>
              </div>
            </th>
            <th className="cellSmall">
              <div className="fixer">
                <BookingsListHeader column="ethnicity">Ethnicity</BookingsListHeader> /
                <BookingsListHeader column="gender">Sex</BookingsListHeader>
              </div>
            </th>
            <th className="cellSmall">
              <div className="fixer">
                <BookingsListHeader column="age">Age</BookingsListHeader>
              </div>
            </th>
            <th className="cellSmall">
              <div className="fixer">
                <BookingsListHeader column="bookingDate">Booking Date</BookingsListHeader>
              </div>
            </th>
            <th className="cellSmall">
              <div className="fixer">
                <BookingsListHeader column="releaseDate">Release Date</BookingsListHeader>
              </div>
            </th>
            <th>
              <div className="fixer">
                <BookingsListHeader column="bookingNumber">Booking #</BookingsListHeader> /
                <BookingsListHeader column="arrestingAgency">Arresting Agency</BookingsListHeader>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking, i) => (
            <BookingsListItem key={i} index={i} booking={booking} />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default BookingsList